import type { Category, EventItem, Photo, Review, Place } from '@/types/home';

// ⛔ 불변 규칙: 취미 카테고리는 아래 6개(여행/나만의 정원/맛집탐방/제작/수집/기타)를 유지한다.
//   '제작'(make)·'수집'(collect)을 '기타'(etc)로 다시 병합하거나 삭제하지 말 것.
//   (project_plan.md '0. 불변 규칙' 참고)
export const mockCategories: Category[] = [
  {
    slug: 'travel',
    name: '여행',
    tagline: '떠나고 싶은 마음을 담다',
    description: '세상 곳곳을 누비며 담은 여행기와 여행 팁을 나눠요. 당일치기부터 장기 여행까지, 떠나는 모든 순간을 기록해요.',
    cover_image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20traveler%20with%20a%20backpack%20overlooking%20rolling%20hills%20and%20coastline%20at%20golden%20hour%2C%20soft%20cream%20sky%2C%20terracotta%20and%20sage%20green%20palette%2C%20magazine%20travel%20journal%20cover%2C%20minimalist%20flat%20style%20with%20subtle%20textured%20grain&width=1200&height=800&seq=cat-travel&orientation=landscape',
    icon: 'ri-suitcase-line',
    board_slugs: ['travel'],
  },
  {
    slug: 'garden',
    name: '나만의 정원',
    tagline: '초록을 가꾸는 일상',
    description: '작은 화분부터 베란다 텃밭까지, 식물을 키우는 즐거움을 나눠요. 성장 기록과 실패담 모두 환영이에요.',
    cover_image: 'https://readdy.ai/api/search-image?query=Cozy%20flat%20illustration%20of%20a%20sunlit%20greenhouse%20filled%20with%20potted%20plants%20and%20hanging%20greenery%2C%20a%20person%20gently%20watering%2C%20warm%20cream%20and%20sage%20green%20palette%2C%20calm%20gardening%20magazine%20aesthetic%2C%20textured%20grain&width=1200&height=800&seq=cat-garden&orientation=landscape',
    icon: 'ri-plant-line',
    board_slugs: ['garden'],
  },
  {
    slug: 'food',
    name: '맛집탐방',
    tagline: '숨은 맛집을 찾아서',
    description: '동네 맛집부터 여행지 별미까지, 미식의 순간을 기록해요. 직접 해먹는 요리 이야기도 함께 나눠요.',
    cover_image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20cozy%20table%20spread%20with%20korean%20comfort%20food%2C%20steaming%20bowls%20and%20colorful%20side%20dishes%2C%20soft%20cream%20background%2C%20terracotta%20and%20amber%20tones%2C%20food%20magazine%20cover%20style%2C%20textured%20grain&width=1200&height=800&seq=cat-food&orientation=landscape',
    icon: 'ri-restaurant-line',
    board_slugs: ['food'],
  },
  {
    slug: 'make',
    name: '제작',
    tagline: '손으로 만드는 즐거움',
    description: '도자기, 목공, 뜨개, 캔들까지 — 직접 손으로 무언가를 만드는 과정과 결과물을 나눠요. 서툴러도 괜찮아요, 만드는 순간이 즐거우니까.',
    cover_image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20cozy%20maker%20workbench%20with%20handmade%20crafts%20and%20tools%2C%20pottery%20and%20yarn%2C%20soft%20cream%20background%2C%20terracotta%20and%20sage%20green%20palette%2C%20craft%20journal%20cover%20style%2C%20textured%20grain&width=1200&height=800&seq=cat-make&orientation=landscape',
    icon: 'ri-hammer-line',
    board_slugs: ['make'],
  },
  {
    slug: 'collect',
    name: '수집',
    tagline: '모으는 사람들의 방',
    description: '피규어, 우표, 빈티지 소품까지 — 소중하게 모아온 수집품과 나만의 컬렉션 이야기를 나눠요.',
    cover_image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20shelf%20filled%20with%20neatly%20arranged%20collectibles%2C%20stamps%2C%20figures%20and%20vintage%20small%20objects%2C%20soft%20cream%20background%2C%20terracotta%20and%20sage%20green%20palette%2C%20collector%20journal%20cover%20style%2C%20textured%20grain&width=1200&height=800&seq=cat-collect&orientation=landscape',
    icon: 'ri-archive-2-line',
    board_slugs: ['collect'],
  },
  {
    slug: 'etc',
    name: '기타',
    tagline: '온갖 취미가 모이는 곳',
    description: '게임, 독서, 꿀팁까지 — 어디에도 끼워넣기 애매한 소중한 취미들을 자유롭게 담아요.',
    cover_image: 'https://readdy.ai/api/search-image?query=Playful%20flat%20illustration%20of%20assorted%20hobby%20objects%2C%20camera%2C%20yarn%20ball%2C%20stamps%2C%20paints%20and%20tools%20arranged%20in%20a%20warm%20grid%2C%20cream%20background%2C%20terracotta%20sage%20and%20amber%20palette%2C%20collectible%20journal%20aesthetic%2C%20textured%20grain&width=1200&height=800&seq=cat-etc&orientation=landscape',
    icon: 'ri-shapes-line',
    board_slugs: ['honey', 'together', 'hobbyist'],
  },
];

export const mockEvents: EventItem[] = [
  {
    id: 'event-1',
    title: '이번 주 인기 취미 글 모음',
    description: '매주 금요일, 커뮤니티에서 가장 사랑받은 취미 이야기를 모아 소개해요.',
    date: '매주 금요일',
    tag: '정기',
    image: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20cozy%20weekly%20digest%20board%20with%20pinned%20notes%20and%20photos%2C%20soft%20cream%20background%2C%20terracotta%20and%20sage%20green%20palette%2C%20community%20newsletter%20aesthetic%2C%20textured%20grain&width=800&height=500&seq=event-1&orientation=landscape',
  },
  {
    id: 'event-2',
    title: '첫 글 남기기 챌린지',
    description: '아직 글을 안 남긴 분들을 위한 챌린지. 첫 취미 이야기를 나눠보세요.',
    date: '상시 진행',
    tag: '이벤트',
    image: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20an%20open%20notebook%20with%20a%20pencil%20and%20a%20small%20trophy%2C%20soft%20cream%20background%2C%20terracotta%20and%20amber%20palette%2C%20welcoming%20challenge%20aesthetic%2C%20textured%20grain&width=800&height=500&seq=event-2&orientation=landscape',
  },
  {
    id: 'event-3',
    title: '봄맞이 식물 자랑 대회',
    description: '내가 키우는 식물의 가장 예쁜 순간을 사진으로 올려주세요. 서로 응원해요.',
    date: '3월 한 달',
    tag: '시즌',
    image: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20colorful%20potted%20plants%20lined%20up%20on%20a%20sunny%20windowsill%2C%20soft%20cream%20background%2C%20sage%20green%20and%20terracotta%20palette%2C%20spring%20contest%20aesthetic%2C%20textured%20grain&width=800&height=500&seq=event-3&orientation=landscape',
  },
  {
    id: 'event-4',
    title: '여행 사진 공모전',
    description: '이번 여름 가장 기억에 남는 순간을 사진 한 장으로 남겨주세요. 수상작은 메인에 소개돼요.',
    date: '7월 한 달',
    tag: '시즌',
    image: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20camera%20and%20printed%20travel%20photos%20pinned%20on%20a%20wall%20with%20string%20lights%2C%20soft%20cream%20background%2C%20terracotta%20and%20amber%20palette%2C%20photo%20contest%20aesthetic%2C%20textured%20grain&width=800&height=500&seq=event-4&orientation=landscape',
  },
  {
    id: 'event-5',
    title: '취미 클럽 모집',
    description: '같은 취미를 가진 사람들과 정기적으로 모여요. 독서, 러닝, 사진 등 클럽별로 신청을 받아요.',
    date: '상시 모집',
    tag: '모집',
    image: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20group%20of%20diverse%20people%20gathered%20around%20a%20table%20sharing%20hobbies%2C%20soft%20cream%20background%2C%20terracotta%20sage%20and%20amber%20palette%2C%20community%20club%20aesthetic%2C%20textured%20grain&width=800&height=500&seq=event-5&orientation=landscape',
  },
  {
    id: 'event-6',
    title: '이달의 댓글왕',
    description: '한 달간 가장 따뜻한 응원과 댓글을 남긴 분을 선정해 소개해요. 진심이 담긴 한마디가 힘이 돼요.',
    date: '매월 말',
    tag: '정기',
    image: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20trophy%20and%20speech%20bubbles%20floating%20around%20a%20cozy%20notebook%2C%20soft%20cream%20background%2C%20terracotta%20and%20sage%20green%20palette%2C%20community%20appreciation%20aesthetic%2C%20textured%20grain&width=800&height=500&seq=event-6&orientation=landscape',
  },
];

export const mockPhotos: Photo[] = [
  {
    id: 'photo-1',
    src: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20turquoise%20sea%20with%20a%20small%20boat%20at%20golden%20hour%2C%20soft%20film%20grain%2C%20cream%20and%20terracotta%20tones%2C%20travel%20journal%20photography%2C%20calm%20composition&width=800&height=800&seq=photo-1&orientation=squarish',
    title: '제주 바다의 황혼',
    category: '여행',
  },
  {
    id: 'photo-2',
    src: 'https://readdy.ai/api/search-image?query=Cozy%20photograph%20of%20a%20monstera%20leaf%20by%20a%20bright%20window%20with%20soft%20morning%20light%2C%20cream%20interior%2C%20sage%20green%20tones%2C%20plant%20journal%20photography%2C%20airy%20composition&width=800&height=800&seq=photo-2&orientation=squarish',
    title: '창가의 몬스테라',
    category: '정원',
  },
  {
    id: 'photo-3',
    src: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20a%20steaming%20bowl%20of%20noodle%20soup%20with%20chopsticks%20on%20a%20wooden%20table%2C%20soft%20natural%20light%2C%20amber%20and%20cream%20tones%2C%20food%20journal%20photography%2C%20appetizing%20composition&width=800&height=800&seq=photo-3&orientation=squarish',
    title: '골목 국수의 온기',
    category: '맛집',
  },
  {
    id: 'photo-4',
    src: 'https://readdy.ai/api/search-image?query=Cozy%20photograph%20of%20handmade%20pottery%20and%20yarn%20on%20a%20wooden%20workbench%2C%20warm%20side%20light%2C%20terracotta%20and%20sage%20tones%2C%20maker%20journal%20photography%2C%20tactile%20composition&width=800&height=800&seq=photo-4&orientation=squarish',
    title: '공방의 오후',
    category: '기타',
  },
  {
    id: 'photo-5',
    src: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20a%20hiking%20trail%20through%20autumn%20hills%20with%20soft%20fog%2C%20muted%20green%20and%20amber%20tones%2C%20film%20grain%2C%20travel%20journal%20photography%2C%20serene%20composition&width=800&height=800&seq=photo-5&orientation=squarish',
    title: '안개 낀 산길',
    category: '여행',
  },
  {
    id: 'photo-6',
    src: 'https://readdy.ai/api/search-image?query=Cozy%20photograph%20of%20a%20small%20herb%20garden%20on%20a%20balcony%20with%20terracotta%20pots%2C%20soft%20afternoon%20light%2C%20sage%20green%20tones%2C%20plant%20journal%20photography%2C%20homey%20composition&width=800&height=800&seq=photo-6&orientation=squarish',
    title: '베란다 허브 정원',
    category: '정원',
  },
];

export const mockReviews: Review[] = [
  {
    id: 'review-1',
    title: '제주 성산 앞 포구의 숨은 회 맛집',
    content: '관광지 바로 옆인데도 현지인만 아는 포구 골목에 있어요. 자연산 광어회가 두툼하고 쫄깃해서 반했어요. 매운탕도 시원하고 사장님 인심이 넉넉해요.',
    author_name: '자파리',
    rating: 5,
    category: '맛집탐방',
    image: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20fresh%20sliced%20raw%20fish%20sashimi%20on%20a%20wooden%20plate%20with%20dipping%20sauce%2C%20coastal%20korean%20restaurant%20table%2C%20soft%20natural%20light%2C%20amber%20and%20cream%20tones%2C%20food%20review%20photography%2C%20appetizing%20close-up&width=800&height=600&seq=review-1&orientation=landscape',
    created_at: '2026-09-02',
  },
  {
    id: 'review-2',
    title: '입문용 필름카메라, 3개월 써본 솔직 후기',
    content: '자동 노출이 잡혀서 초보도 부담 없어요. 다만 가격 대비 바디가 좀 가벼워서 그립감은 아쉽네요. 결과물 색감은 정말 따뜻해서 만족해요.',
    author_name: '수집가K',
    rating: 4,
    category: '기타',
    image: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20a%20vintage%20film%20camera%20on%20a%20wooden%20table%20with%20developed%20photos%20scattered%20around%2C%20soft%20side%20light%2C%20terracotta%20and%20cream%20tones%2C%20product%20review%20photography%2C%20nostalgic%20composition&width=800&height=600&seq=review-2&orientation=landscape',
    created_at: '2026-08-27',
  },
  {
    id: 'review-3',
    title: '베란다 텃밭에 딱 맞는 미니 화분 추천',
    content: '배수 구멍이 깊어서 물빠짐이 좋아요. 사이즈도 딱 맞고 색감도 은은해서 집 분위기 살려줘요. 초록이 집사라면 한 번쯤 써볼 만해요.',
    author_name: '초록이',
    rating: 5,
    category: '나만의 정원',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20photograph%20of%20small%20terracotta%20pots%20with%20young%20herbs%20on%20a%20balcony%20shelf%2C%20soft%20afternoon%20light%2C%20sage%20green%20and%20cream%20tones%2C%20plant%20product%20review%20photography%2C%20airy%20composition&width=800&height=600&seq=review-3&orientation=landscape',
    created_at: '2026-08-20',
  },
  {
    id: 'review-4',
    title: '동해안 드라이브 코스, 해안도로 정리',
    content: '강릉부터 양양까지 바다를 끼고 달리는 코스예요. 중간중간 바다 보이는 카페가 많아서 쉬어가기 좋았어요. 주말엔 차가 막히니 평일 추천해요.',
    author_name: '지하',
    rating: 4,
    category: '여행',
    image: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20a%20coastal%20drive%20road%20winding%20along%20the%20blue%20sea%20at%20golden%20hour%2C%20soft%20film%20grain%2C%20terracotta%20and%20cream%20tones%2C%20travel%20review%20photography%2C%20expansive%20composition&width=800&height=600&seq=review-4&orientation=landscape',
    created_at: '2026-08-12',
  },
  {
    id: 'review-5',
    title: '동네에서 찾은 아담한 독립서점',
    content: '작은 공간인데 큐레이션 센스가 좋아요. 취미 관련 책이 많고 구석에 앉아 읽을 공간도 있어요. 조용한 오후 보내기 좋은 곳이에요.',
    author_name: '자파리',
    rating: 4,
    category: '기타',
    image: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20a%20cozy%20independent%20bookstore%20interior%20with%20wooden%20shelves%20and%20a%20reading%20nook%2C%20soft%20warm%20light%2C%20amber%20and%20cream%20tones%2C%20place%20review%20photography%2C%20inviting%20composition&width=800&height=600&seq=review-5&orientation=landscape',
    created_at: '2026-08-05',
  },
  {
    id: 'review-6',
    title: '몬스테라 물주기, 이 앱 하나로 해결',
    content: '식물별 물 주는 주기를 알림으로 관리해줘서 과습을 줄였어요. 무료 버전도 충분히 쓸만하고, 사진으로 기록하는 기능이 특히 좋네요.',
    author_name: '초록이',
    rating: 5,
    category: '나만의 정원',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20photograph%20of%20a%20smartphone%20showing%20a%20plant%20care%20app%20next%20to%20a%20monstera%20plant%2C%20soft%20morning%20light%2C%20sage%20green%20and%20cream%20tones%2C%20app%20review%20photography%2C%20clean%20composition&width=800&height=600&seq=review-6&orientation=landscape',
    created_at: '2026-07-29',
  },
];

export const mockPlaces: Place[] = [
  {
    id: 'place-1',
    name: '성산일출봉 포구',
    location: '제주 서귀포시 성산읍',
    category: '여행',
    description: '일출 명소로 유명하지만, 발 아래 포구의 한적한 분위기가 더 좋아요. 새벽 바다와 어선들이 어우러진 풍경을 담기 좋은 곳이에요.',
    image: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20a%20quiet%20fishing%20harbor%20at%20sunrise%20with%20small%20boats%20and%20a%20distant%20volcano%20peak%2C%20soft%20film%20grain%2C%20terracotta%20and%20cream%20tones%2C%20travel%20place%20photography%2C%20serene%20composition&width=800&height=600&seq=place-1&orientation=landscape',
    tags: ['일출', '바다', '사진'],
  },
  {
    id: 'place-2',
    name: '숲속 수목원',
    location: '경기 포천시',
    category: '나만의 정원',
    description: '계절마다 다른 식물을 만날 수 있는 수목원이에요. 산책로가 잘 정비돼 있어서 식물 구경하며 천천히 걷기 좋아요.',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20photograph%20of%20a%20peaceful%20botanical%20garden%20path%20lined%20with%20lush%20greenery%20and%20flowers%2C%20soft%20dappled%20light%2C%20sage%20green%20and%20cream%20tones%2C%20garden%20place%20photography%2C%20tranquil%20composition&width=800&height=600&seq=place-2&orientation=landscape',
    tags: ['산책', '식물', '가족'],
  },
  {
    id: 'place-3',
    name: '골목 미식거리',
    location: '서울 마포구',
    category: '맛집탐방',
    description: '오래된 골목에 숨은 맛집이 모여 있는 거리예요. 낮에는 국수, 밤에는 포장마차까지 하루 종일 맛있어요.',
    image: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20a%20lively%20alley%20food%20street%20with%20small%20eateries%20and%20warm%20glowing%20signs%2C%20evening%20light%2C%20amber%20and%20cream%20tones%2C%20food%20place%20photography%2C%20bustling%20composition&width=800&height=600&seq=place-3&orientation=landscape',
    tags: ['맛집', '야시장', '데이트'],
  },
  {
    id: 'place-4',
    name: '해안 카페 거리',
    location: '강원 강릉시',
    category: '여행',
    description: '바다가 바로 보이는 카페들이 줄지어 있어요. 창가에 앉아 커피 마시며 파도 소리를 듣는 게 최고예요.',
    image: 'https://readdy.ai/api/search-image?query=Warm%20photograph%20of%20a%20row%20of%20ocean-view%20cafes%20with%20large%20windows%20facing%20the%20blue%20sea%2C%20soft%20afternoon%20light%2C%20cream%20and%20terracotta%20tones%2C%20travel%20place%20photography%2C%20relaxing%20composition&width=800&height=600&seq=place-4&orientation=landscape',
    tags: ['카페', '바다', '드라이브'],
  },
  {
    id: 'place-5',
    name: '작은 공방 골목',
    location: '서울 종로구',
    category: '기타',
    description: '도자기, 가죽, 캔들 등 다양한 공방이 모인 골목이에요. 원데이 클래스도 많아서 취미 입문하기 좋아요.',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20photograph%20of%20a%20narrow%20artisan%20alley%20with%20small%20craft%20workshops%20and%20handmade%20goods%20on%20display%2C%20warm%20light%2C%20terracotta%20and%20sage%20green%20tones%2C%20maker%20place%20photography%2C%20charming%20composition&width=800&height=600&seq=place-5&orientation=landscape',
    tags: ['공방', '원데이클래스', '만들기'],
  },
  {
    id: 'place-6',
    name: '도심 속 식물원',
    location: '서울 마포구',
    category: '나만의 정원',
    description: '빌딩 사이에 숨어 있는 실내 식물원이에요. 희귀한 식물도 많고 사진 찍기 좋은 포인트가 곳곳에 있어요.',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20photograph%20of%20a%20modern%20indoor%20botanical%20garden%20with%20tall%20plants%20and%20glass%20ceiling%2C%20soft%20filtered%20light%2C%20sage%20green%20and%20cream%20tones%2C%20garden%20place%20photography%2C%20airy%20composition&width=800&height=600&seq=place-6&orientation=landscape',
    tags: ['식물원', '데이트', '사진'],
  },
];